import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ENV_QUERY_KEY, useEnv } from '../../../context/env-context';
import { useHandlers, useSite } from '../../../context/page-context';
import { SETTINGS_QUERY_KEY } from '../../../context/settings-context';
import type { PlatformConnectRequest, PlatformConnectResponse } from '../types';

export function useConnectPlatform() {
  const { apis, navigationHandler } = useHandlers();
  const site = useSite();
  const env = useEnv();
  const queryClient = useQueryClient();

  return useMutation<PlatformConnectResponse, unknown, PlatformConnectRequest>({
    mutationFn: (payload) => apis.platform.connect(env.team.slugged_name, env.environment, payload),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({
        queryKey: [ENV_QUERY_KEY, site.siteId, site.siteEnv],
      });
      void queryClient.invalidateQueries({ queryKey: SETTINGS_QUERY_KEY });

      if (data.redirect_to) {
        navigationHandler.navigate(data.redirect_to, { absolute: true, top: true });
      }
    },
  });
}
